import * as React from 'react';

import { Grid,  Button, Link, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { Trans, TransProps, WithTranslation, withTranslation } from 'react-i18next';

import { window2config } from '../../cfg/config';
import CONFIG from '../../cfg/config';

import { List, ListItem, Typography, ListItemText, ListItemIcon } from '@material-ui/core';
import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState } from '../../appredux';

import { hotelService, webHotel, PortalInfo, Info, webRooms, roomsService, webRoom, passService, Bramka, Result, resetService } from '../../api';
import { ClassNameMap } from '@material-ui/styles';
import theme from '../../themes';
import ResponsiveImgMaterialUi from "responsive-img-material-ui";

import zdjecie from './../../zdjecia/zanocuj.png'
import HotelIcon from '@mui/icons-material/Hotel';
import SearchIcon from '@material-ui/icons/Search';
import OknoMapa from '../wypozycz/OknoMapa';
import DialogLink from 'components/DialogLink';
import { sendErrorLog } from 'common/helpers';



interface DoladujKarnetProps {
  page: IPageState,
}

interface DoladujKarnetState {
  openMapa: boolean,
  openLink: boolean,
}



class DoladujKarnet extends React.Component<DoladujKarnetProps & WithTranslation & TransProps & WithStyles<typeof styles>, DoladujKarnetState> {

  constructor(props: DoladujKarnetProps & WithTranslation & WithStyles<typeof styles>) {
    super(props, {});
    window2config();
   
    this.state = {
      openMapa: false,
      openLink: false,
    }
  }

  componentDidMount() {
    sendErrorLog("1", "1", 'zanocuj')
  }

  rezerwuj = () => {
    if(CONFIG.karnetZanocujLink === "1"){
      window.open("https://vsc24.net/vscHotelBook/hotel/lesko-SKI", "_blanc")
    } else {
      this.openLink()
    }
  }

  openMapa = () => {
    this.setState({openMapa: true})
  }
  closeMapa = () => {
    this.setState({openMapa: false})
  }
  openLink = () => {
    this.setState({openLink: true})
  }
  closeLink = () => {
    this.setState({openLink: false})
  }

  
  render() {
    const { classes, t } = this.props;
    let primary = theme.palette.primary.main

    let disabled = !this.props.page.jestKarnet
    

      return (
          <Grid container spacing={2} className={classes.container1} justify="center" alignItems="center"  >
              <Grid item xs={12} sm={12} className={classes.gridItem} >
                
                  {/* <div style={{
                      textAlign: 'center',
                  }}>

                      <ResponsiveImgMaterialUi style={{ width: "85%", maxWidth: "330px" }}
                          xs={zdjecie}
                      />
                  </div> */}


                  <div style={{width: "fit-content", margin: "auto"}}>
                      <Typography variant="h6" component="h2" onClick={() => this.openMapa()} color='textSecondary' className={classes.text} style={{cursor: "pointer"}}>
                          <SearchIcon className={classes.icon} style={{fontSize: "28px", marginRight: "6px"}} />
                          <Link target='_blank' underline="hover" className={classes.color} style={{}}>{'zobacz gdzie pokoje i domki'}</Link>
                          {/* {"Ty lajkujesz"}<b className={classes.primary} >{ }</b> */}
                      </Typography>
                      <Typography variant="h6" component="h2" onClick={() => this.rezerwuj()} color='textSecondary' className={classes.text} style={{cursor: "pointer"}}>
                          <HotelIcon className={classes.icon} />
                          <Link  target='_blank' underline="hover" className={classes.color}>{'zarezerwuj'}</Link>
                          {/* {"Ty lajkujesz"}<b className={classes.primary} >{ }</b> */}
                      </Typography>
                  </div>    

                  
                  <DialogLink open={this.state.openLink} close={this.closeLink} title="zarezerwuj" text="funkcja chwilowo wyłączona" />

                  <OknoMapa open={this.state.openMapa} closeDialog={this.closeMapa} zdjecie={zdjecie} tytul={"pokoje i domki"}/>
              </Grid>
          </Grid>
      );
  }
}

const styles = (theme: Theme) => ({
  container1: {
    //margin: "0em",
    //paddingTop: "0.4em",
    margin: "30px auto 0px",
    padding: '0em 0em',
    minHeight: "100%",
    maxWidth: "1340px",
    //border: "2px solid lavender"
  },
  gridItem: {
    minHeight: "150px",
  },
  item: {
    height: "40px",
    textAlign: "center" as "center",
    border: "1px solid lavender",
    marginBottom: "4px",
    backgroundColor: "#FCFCFC", //"#F5F5F5",
    paddingLeft: "0",
    paddingRight: "0",
    "&:hover": {
      backgroundColor: "#F1F1F1", //"#EEE"
    },
  },
  itemText: {
    color: "rgb(255, 165, 0)",
    fontSize: "14px"//16px //"2.5rem"
  },
  color: {
    color: "lightseagreen"
  },
  text: {
    color: theme.palette.text.secondary,
    whiteSpace: "pre" as "pre",
    minHeight: "12px",
    marginTop: '12px',
    marginBottom: '12px',
    fontSize: "16px",

    display: "flex" as "flex",
    justyfyContent: "center",
    alignItems: "center"
  },
  icon: {
    fontSize: "30px", 
    color: "rgb(255, 165, 0)", 
    marginRight: "10px"
  },

});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(DoladujKarnet))); 

